import React, { useEffect, useState } from 'react';
import {Button,Modal,ModalOverlay,ModalContent,ModalHeader,ModalCloseButton,ModalBody,Box} from '@chakra-ui/react';
import { Col, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { InputGroup } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
import SpinnerLoader from 'components/Spinner/SpinnerLoader';
import { useToasts } from 'react-toast-notifications';
import { useDispatch } from 'react-redux';
import { poNumberFormate } from 'jsFunctions/helperFunctions';
import { fetchAsyncUpdateCredit } from 'redux/creditSlice';
import { BsFillFileEarmarkPdfFill } from 'react-icons/bs';
import { fetchAsyncFilePreviewData } from 'redux/userSlice';
import { fetchAsyncGetNewCreditNumber } from 'redux/creditSlice';
import { fetchAsyncAddCreditByVendor } from 'redux/creditSlice';

const VendorEditCreditForm = (
    {
        closeModal,
        openModal,
        editData,
        isEdit,
        vendorId,    
        clientId
    }) => {

    const { addToast } = useToasts();
    const dispatch = useDispatch();
    const [creditAmountError,setCreditAmountError] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [creditNumber,setCreditNumber] = useState("")
    const [selectedFile, setSelectedFile] = useState("")
    const [paymentAmount, setPaymentAmount] = useState(0);
    const  [selectedDate, setSelectedDate] = useState("")
    const [remarks,setRemarks] = useState("")
    const [errors,setErrors] = useState({})

    const validate = () => {
      const newErrors = {};
  
      if (!paymentAmount)
        newErrors.amount = "amount is required!";
      if (!selectedDate){
        newErrors.paymentDate = "Date is required!";
      }
  
     
      setCreditAmountError(newErrors);
  
     
      return Object.keys(newErrors).length === 0;
    };
    const handleFileChange = (e) => {
        if (e.target.files) {
          if (e.target.files[0].size < 2 * 1024 * 1024) {
            setSelectedFile(e.target.files[0]);
          } else {
            addToast("Please attach file less then 2Mb", { appearance: "warning" });
          }
        }
    };

   
    const generateNewCreditNumber = async()=>{
      const data = {}
      await dispatch(fetchAsyncGetNewCreditNumber(data)).then((res)=>{
    
        if(res?.payload){
          const crNo = res?.payload?.crNo;
          const formatedCrNum = poNumberFormate(crNo)
          setCreditNumber(formatedCrNum)
        }
        }).catch((err)=>{
          addToast(`Error while fetching credit number!`,{ appearance: "error" });
    
        })
  }
    useEffect(()=>{
        if(editData?._id){
            if(editData?.crNo){
             setCreditNumber(poNumberFormate(editData?.crNo))
            } 
            if(editData?.rmks){
            setRemarks(editData?.rmks)
            }
            if(editData?.amt){
                setPaymentAmount(editData?.amt)
            }
            if(editData?.pmtDt){
                setSelectedDate(new Date(editData?.pmtDt))
            }
        }
        else{
          generateNewCreditNumber();
        }
    },[editData])
   
    
      const handleRemarksChange = (e)=>{
        const value = e?.target?.value;
        const encoder = new TextEncoder(); 
        const byteLength = encoder.encode(value).length;
        if(byteLength <=256){
          setRemarks(value)
          setErrors({
            ...errors,
            remarks:''
          })
        }
        else{
          setErrors({
            ...errors,
            remarks:'Remarks must be within the 256 byte limit!'
          })
        }
      }

      const handleUpdateCredit = async()=>{           
        if(paymentAmount < editData?.usAmt){
                setCreditAmountError({amount:"Credit amount cannot be less than used amount."})
                return;
        }
        if(paymentAmount > editData?.amt){
          setCreditAmountError({amount:"The amount entered exceeds the available limit."})
          return;
        }
        else{
            setCreditAmountError({})
        }

        let formData = new FormData();
      
        formData.append("amount", paymentAmount);
        formData.append("date", selectedDate);
        formData.append("file", selectedFile);
        formData.append("remarks", remarks);

        try {
            
            setIsLoading(true)
            
            dispatch(
                fetchAsyncUpdateCredit({id:editData?._id,formData})
              ).then((res) => {
                if(res?.payload){
                addToast(`credit Updated successfully`);
                closeModal()
                }
                else{
                  setIsLoading(false);
                  addToast(`credit not updated`, { appearance: "error" });
                }
    
              }).catch((error) => {
                addToast(`Error while fetching add new credit!!`, { appearance: "error" });
                setIsLoading(false);
            });

        } catch (error) {
            addToast(`Error while fetching add new credit!`,{ appearance: "error" });
            setIsLoading(false);
        }
      }

      const handleAddCredit = async()=>{    
        let formData = new FormData();
        formData.append("crNo", creditNumber);
        formData.append("vendorId", vendorId);
        formData.append("clientId", clientId);
        formData.append("amount", paymentAmount);
        formData.append("date", selectedDate);
        formData.append("file", selectedFile);
        formData.append("remarks", remarks);

        try {
            
            setIsLoading(true)
           
              dispatch(
                fetchAsyncAddCreditByVendor({formData})
              ).then((res) => {
                if(res?.payload){
                  addToast(`credit created successfully`);
                  closeModal()
                }
                else{
                  addToast(`creadit not created`, { appearance: "error" });
                }
    
              }).catch((error) => {
                setIsLoading(false);
              }).finally(()=>{
                setIsLoading(false);
              });
           
        } catch (error) {
            addToast(`Error while fetching add new credit!`,{ appearance: "error" });
            setIsLoading(false);
        }
    }
    
      const handleSubmit = (e)=>{
        e.preventDefault();
        if(validate()){
          if(isEdit && editData?._id){
            handleUpdateCredit()
          }
          else{
            handleAddCredit()
          }
        }
      }
    const handleFilePreview = async (key, spId) => {
      setIsLoading(true)

      try {
        const data = { key:key, spId:spId };
        const response = await dispatch(fetchAsyncFilePreviewData(data)).unwrap();
        const contentType = response.headers['Content-Type'] || response.headers['content-type']; 
        
        const blob = new Blob([response.data], { type: contentType });
        const pdfUrl = window.URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank'); 
        setIsLoading(false)

      } catch (error) {
        setIsLoading(false)

        addToast(`Error fetching PDF preview: ${error.message}`, { appearance: "error" });
      }
    };
    return (
      <>
        <Modal
          isOpen={openModal}
          onClose={closeModal}
          className="modal-main"
          size="lg"
        >
          <ModalOverlay />
          <ModalContent
            className="info-model"
            top="0"
            margin="0 auto"
            bottom="0"
            maxH="350px"
          >
            <div className="fixed-header">
              <ModalHeader className="expense-modal-header mt-0">
                {!isEdit ? "Add Credit" : <div>Credit - <span className="header-pr blue">{creditNumber}</span></div>} 
              </ModalHeader>
              <ModalCloseButton />
            </div>
            {isLoading ? (
              <SpinnerLoader />
            ) : (
              <ModalBody>
                <Form className="edit-credit-form">
                  <div className="form-card">
                    <Row className="mt-2">
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Credit Number <span className="span-star">*</span>
                          </Form.Label>

                          <Form.Control
                            type="text"
                            name="poNo"
                            value={creditNumber}
                            disabled
                          />
                        </Box>
                      </Col>

                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Credit Amount <span className="span-star">*</span>
                          </Form.Label>
                          <Box>

                          <InputGroup>
                            <InputGroup.Text>
                              <span className="rupee-symbol">₹</span>{" "}
                            </InputGroup.Text>
                            <CurrencyFormat
                              customInput={Form.Control}
                              type="text"
                              disabled={editData?.amt === editData?.usAmt && isEdit}
                              defaultValue={paymentAmount}
                              value={paymentAmount || ""}
                              onValueChange={(e) => {
                                setPaymentAmount(e.value);
                              }}
                              thousandSeparator={true}
                              // prefix={"$"}
                              decimalScale={2}
                              fixedDecimalScale={true}
                            />
                          </InputGroup>
                        <p className="form_error">
                          {" "}
                          {creditAmountError?.amount}
                        </p>
                          </Box>
                        </Box>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Credit Date <span className="span-star">*</span>
                          </Form.Label>

                          <Box>
                            <DatePicker
                              name="paymentdate"
                              className="monthDate"
                              dateFormat="dd-MMM-yyyy"
                              selected={selectedDate}
                              onChange={(date) => {
                                setSelectedDate(date);
                              }}
                              onFocus={() => {
                                if (!selectedDate) {
                                  const defaultDate = new Date();
                                  setSelectedDate(defaultDate);
                                }
                              }}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                            />
                        <p className="form_error">
                          {" "}
                          {creditAmountError?.paymentDate}
                        </p>
                          </Box>
                        </Box>
                      </Col>
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>Upload File (img/pdf)</Form.Label>
                          <Box display="flex">
                            <Form.Control
                              type="file"
                              style={{ width: "210px" }}
                              name="creditfile"
                              placeholder="PDF"
                              onChange={(e) => handleFileChange(e)}
                              accept="image/pdf"
                            />
                            {editData?.fils?.key ? (
                              <BsFillFileEarmarkPdfFill
                                style={{ cursor: "pointer" }}
                                className='mx-2 mt-2'
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFilePreview(
                                    editData?.fils?.key,
                                    editData?.fils?.spId
                                  );
                                }}
                              />
                            ) : (
                              <BsFillFileEarmarkPdfFill
                                style={{ cursor: "not-allowed" }}
                                color="gray"
                                className='mx-2 mt-2'

                              />
                            )}
                          </Box>
                        </Box>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>Remarks </Form.Label>
                          <Box>

                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="remarks"
                            placeholder="Type Here..."
                            value={remarks}
                            onChange={(e) => handleRemarksChange(e)}
                            isInvalid={!!errors?.remarks}
                          />
                      <p className="form_error">{errors?.remarks}</p>
                          </Box>
                        </Box>
                      </Col>
                    </Row>

                    <Box
                      className="mt-4"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Button
                        className="submit-btn mt-2"                        
                        onClick={(e) => handleSubmit(e)}
                        colorScheme="green"
                      >
                        {isEdit ? 'Update' :'Add'}
                      </Button>
                    </Box>
                  </div>
                </Form>
              </ModalBody>
            )}
          </ModalContent>
        </Modal>
      </>
    );
};

export default VendorEditCreditForm;
